module.exports = __webpack_public_path__ + "static/media/account-icon.f91e8b61.svg";